// Placeholder portrait — deterministic gradient + initials, no external deps.
import React from "react";

const PALETTES = [
  ["#FF107A", "#7A0F3E", "#FFD700"],
  ["#A855F7", "#3B1663", "#00E5FF"],
  ["#00E5FF", "#0C4A6E", "#FF107A"],
  ["#FFD700", "#7A5F00", "#FF107A"],
  ["#FF6B35", "#5A1B00", "#FDFBF7"],
  ["#22D3EE", "#164E63", "#A855F7"],
  ["#F472B6", "#831843", "#FDFBF7"],
  ["#84CC16", "#365314", "#FDFBF7"],
];

const hash = (str) => {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h;
};

const initials = (name) =>
  name.split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase() || "").join("");

export const CelebPortrait = ({ name, size = 140, selected = false, dim = false, testId }) => {
  const p = PALETTES[hash(name) % PALETTES.length];
  return (
    <div
      data-testid={testId}
      className="relative rounded-3xl overflow-hidden flex items-end justify-center transition-all"
      style={{
        width: size,
        height: size * 1.25,
        background: `linear-gradient(160deg, ${p[0]} 0%, ${p[1]} 100%)`,
        border: selected ? `3px solid ${p[2]}` : "3px solid rgba(255,255,255,0.08)",
        boxShadow: selected ? `0 0 32px ${p[2]}66` : "none",
        opacity: dim ? 0.35 : 1,
        filter: dim ? "grayscale(0.6)" : "none",
      }}
    >
      <span
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-[60%] font-display leading-none"
        style={{
          fontSize: size * 0.62, color: p[2], textShadow: `0 4px 24px ${p[1]}`,
          letterSpacing: "-0.03em",
        }}
      >
        {initials(name)}
      </span>
      <div
        className="w-full px-2 py-2 text-center font-display truncate"
        style={{
          background: "linear-gradient(0deg, rgba(0,0,0,0.7), transparent)",
          fontSize: size * 0.11, color: "#FDFBF7",
        }}
      >
        {name}
      </div>
    </div>
  );
};
